module.exports = {"TXTMOB_Give_Feedback":{"id":"TXTMOB_Give_Feedback","defaultMessage":"Γράψε σχόλια"}}